import _slicedToArray from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "sticky-header-wrapper mb-14"
};
var _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass(['py-1.5 pr-0 mx-3.5'])
};
var _hoisted_3 = {
  class: "flex flex-col gap-0 w-full"
};
var _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-2"
};
var _hoisted_5 = {
  key: 1,
  class: "w-full h-[28px] flex items-center justify-center text-sm font-semibold text-surface-400"
};
import { ref, computed, watch } from "vue";
import TreeTable from "primevue/treetable";
import Column from "primevue/column";
import { useRouter } from "vue-router";
import TimeOffTreeTableHeader from "@/components/overview/time-off/TimeOffTreeTableHeader.vue";
import DailyCols from "@/components/overview/time-off/cols/TimeOffDailyCols.vue";
import MainParentCell from "@/components/overview/time-off/cell/TimeOffMainParentCell.vue";
import MainTimeTableCell from "@/components/overview/time-off/cell/TimeOffMainTimeTableCell.vue";
import { OVERVIEW_TABS } from "@/utils/const";
import network from "@/utils/network";
export default {
  __name: 'TimeOffTreeTable',
  setup: function setup(__props) {
    var filters = ref({
      query: "",
      team: [],
      onTimeOff: [true]
    });
    var headerLabels = computed(function () {
      var _timeOffItems$value$;
      return ((_timeOffItems$value$ = timeOffItems.value[0]) === null || _timeOffItems$value$ === void 0 ? void 0 : _timeOffItems$value$.timeIntervalValues.map(function (interval) {
        return interval.id;
      })) || [];
    });

    // region Selected from and to
    var router = useRouter();
    var from = router.currentRoute.value.query.from;
    var to = router.currentRoute.value.query.to;
    var selectedFromAndTo = ref({
      from: from ? from : null,
      to: to ? to : null
    });
    var startDate = computed(function () {
      return selectedFromAndTo.value.from;
    });
    var endDate = computed(function () {
      return selectedFromAndTo.value.to;
    });
    // endregion
    // Data
    var axios = network.createAxiosInstance();
    var timeOffItems = ref([]);
    var isLoadingOverview = ref(true);
    var overviewError = ref(null);
    var showOverviewSkeleton = ref(false);
    var queryParams = computed(function () {
      var _filters$value$team;
      var params = new URLSearchParams();
      var requiredDataTypes = ["ALLOCATION", "WORK_SCHEDULE", "TIME_OFF"];
      params.set("startDate", startDate.value);
      params.set("endDate", endDate.value);
      if (filters.value.query) {
        params.set("query", filters.value.query);
      }
      if ((_filters$value$team = filters.value.team) !== null && _filters$value$team !== void 0 && _filters$value$team.length) {
        filters.value.team.forEach(function (t) {
          params.append("team", t);
        });
      }
      if (filters.value.onTimeOff) {
        filters.value.onTimeOff.forEach(function (t) {
          params.append("timeOff", t ? "true" : "false");
        });
      }
      requiredDataTypes.forEach(function (field) {
        params.append("dataType", field);
      });
      return "?".concat(params.toString());
    });
    var fetchOverview = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              isLoadingOverview.value = true;
              overviewError.value = null;
              timeOffItems.value = [];
              _context.p = 1;
              _context.n = 2;
              return axios.get("/v2/absence/time-off/overview".concat(queryParams.value));
            case 2:
              response = _context.v;
              timeOffItems.value = response.data || [];
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
            case 4:
              _context.p = 4;
              isLoadingOverview.value = false;
              showOverviewSkeleton.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function fetchOverview() {
        return _ref.apply(this, arguments);
      };
    }();
    watch(queryParams, function () {
      if (!startDate.value || !endDate.value) {
        return;
      } else {
        fetchOverview();
      }
    }, {
      immediate: true
    });

    // expandedKeys
    var expandedKeys = ref([]);

    // Url search params - selected interval
    watch(function () {
      return [selectedFromAndTo.value];
    }, function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        newSelectedFromAndTo = _ref3[0];
      var queryParams = new URLSearchParams();

      // Preserve existing query params
      var currentQuery = router.currentRoute.value.query;
      Object.keys(currentQuery).forEach(function (key) {
        if (key !== "tab" && key !== "from" && key !== "to") {
          queryParams.set(key, currentQuery[key]);
        }
      });

      // Set new query params
      queryParams.set("tab", OVERVIEW_TABS.TIME_OFF.value);
      if (newSelectedFromAndTo !== null && newSelectedFromAndTo !== void 0 && newSelectedFromAndTo.from && newSelectedFromAndTo !== null && newSelectedFromAndTo !== void 0 && newSelectedFromAndTo.to) {
        queryParams.set("from", newSelectedFromAndTo === null || newSelectedFromAndTo === void 0 ? void 0 : newSelectedFromAndTo.from);
        queryParams.set("to", newSelectedFromAndTo === null || newSelectedFromAndTo === void 0 ? void 0 : newSelectedFromAndTo.to);
      }
      router.push({
        query: Object.fromEntries(queryParams)
      });
    });
    return function (_ctx, _cache) {
      var _component_Skeleton = _resolveComponent("Skeleton");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(TimeOffTreeTableHeader, {
        class: "border rounded-t-lg px-3.5 py-2 border-surface-100 bg-surface-0",
        "selected-from-and-to": selectedFromAndTo.value,
        "onUpdate:selectedFromAndTo": _cache[0] || (_cache[0] = function ($event) {
          return selectedFromAndTo.value = $event;
        }),
        filters: filters.value,
        "onUpdate:filters": _cache[1] || (_cache[1] = function ($event) {
          return filters.value = $event;
        })
      }, null, 8, ["selected-from-and-to", "filters"]), _createElementVNode("div", _hoisted_1, [_createVNode(_unref(TreeTable), {
        value: timeOffItems.value,
        scrollable: "",
        expandedKeys: expandedKeys.value,
        "onUpdate:expandedKeys": _cache[2] || (_cache[2] = function ($event) {
          return expandedKeys.value = $event;
        })
      }, {
        empty: _withCtx(function () {
          return [isLoadingOverview.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, function (i) {
            return _createVNode(_component_Skeleton, {
              key: i,
              class: "w-full !h-[84px]"
            });
          }), 64)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, function (i) {
            return _createVNode(_component_Skeleton, {
              key: i,
              class: "w-full !h-[56px]"
            });
          }), 64))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$tf("timeManagementOverview.noData|Nincs adat")), 1))];
        }),
        default: _withCtx(function () {
          return [_createVNode(_unref(Column), {
            field: "userId",
            header: "",
            frozen: "",
            style: {
              "padding": "0 !important"
            },
            class: "!border-r !border-surface-100",
            pt: {
              bodycellContent: '!justify-end !h-[54px]',
              headercell: {
                style: 'background-color: var(--p-surface-0) !important;'
              }
            }
          }, {
            body: _withCtx(function (_ref4) {
              var node = _ref4.node;
              return [_createElementVNode("div", _hoisted_2, [_createVNode(MainParentCell, {
                node: node
              }, null, 8, ["node"])])];
            }),
            _: 1
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerLabels.value, function (interval) {
            return _openBlock(), _createBlock(_unref(Column), {
              key: interval,
              style: {
                "min-width": "100px",
                "padding": "0 !important"
              },
              pt: {
                bodycell: '!border-b-0'
              }
            }, {
              header: _withCtx(function () {
                return [_createVNode(DailyCols, {
                  "time-off-items": timeOffItems.value,
                  interval: interval,
                  "is-loading": isLoadingOverview.value
                }, null, 8, ["time-off-items", "interval", "is-loading"])];
              }),
              body: _withCtx(function (_ref5) {
                var node = _ref5.node;
                return [_createElementVNode("div", _hoisted_3, [_createVNode(MainTimeTableCell, {
                  node: node,
                  "interval-id": interval,
                  field: "timeOff"
                }, null, 8, ["node", "interval-id"])])];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      }, 8, ["value", "expandedKeys"])])]);
    };
  }
};